import React, { useEffect, useRef } from "react";
import "../Style/Trustedclients.css";

import logo1 from "../assets/seoways.png";
import logo2 from "../assets/thariga.png";
import logo3 from "../assets/kr.png";
import logo4 from "../assets/book.png";
import logo5 from "../assets/fly.png";
import logo6 from "../assets/ciet.png";
import logo7 from "../assets/greentech.png";
import logo8 from "../assets/pragyalogo.png";
import logo9 from "../assets/SOA Logo.png";
import logo10 from "../assets/KING   LOGO.png";
import logo11 from "../assets/KKCAS_logo.png";
import logo13 from "../assets/Arklon logo.png";
import logo12 from "../assets/kkb.webp";
import logo14 from "../assets/rmrishi.png";
import logo16 from "../assets/kqlogo.png";
import logo17 from "../assets/Orchid Logo.png";
import logo15 from "../assets/cimat.png";
import logo18 from "../assets/edge.png";
import logo19 from "../assets/ln.png";
import logo20 from "../assets/build.png";
import logo21 from "../assets/power.png";
import logo22 from "../assets/kannan.png";
import logo23 from "../assets/salkarain.png";
import logo24 from "../assets/logo33.gif";
import logo25 from "../assets/nakshathra.jpeg"; 
import logo26 from "../assets/thulasi.jpeg";
import logo27 from "../assets/reboot.png";

const TrustedClients = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add("show");
        } else {
          sectionRef.current.classList.remove("show");
        }
      },
      { threshold: 0.4 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);

    return () => observer.disconnect();
  }, []);

  const logos = [logo1, logo2, logo3, logo4, logo5,logo6,logo7,logo8,logo9,logo10,logo11,logo12,logo13,logo14,logo15,logo16,logo17,logo18,logo19,logo20,logo21,logo22,logo23,logo24,logo25,logo26,logo27];

  return (
    <section className="trusted-section" ref={sectionRef}>
      <span className="tc-eyebrow fade-item">Trusted By</span>
      <h2 className="fade-item">Trusted Clients</h2>

      <p className="fade-item">
        Every great product starts as a thought. <br />
        We help that thought grow, evolve, and turn into something people
        actually love to use.
      </p>

      <div className="logo-slider fade-item">
        <div className="logo-track">
          {[...logos, ...logos].map((logo, index) => (
            <div className="logo-item" key={index}>
              <div className="logo-card">
                <img src={logo} alt="client logo" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedClients;